<template>
  <div class="news-content">
    <div class="news-tab">
      <div
        v-for="(item, key) in newsType"
        :key="key"
        class="news-tab__item"
        :class="getTabClass(key, item)"
        @click="changeTab(item.type)"
      >
        <div class="image"></div>
        <div class="news-tab__seperator" v-if="key != newsType.length - 1"></div>
      </div>
    </div>
    <div class="news-list">
      <template v-for="(newsItem, newsType) in newsList">
        <div
          :key="newsType"
          class="box"
          v-if="activeTab == newsType"
        >
          <ul>
            <li
              v-for="(item, key) in newsItem"
              :key="key"
              class="news-item"
            >
              <span class="tag">{{ item.tag }}</span>
              <span class="title" :title="item.title" @click="viewMobileNews(item)">{{ item.title }}</span>
              <span class="time">{{ item.time }}</span>
            </li>
          </ul>
        </div>
      </template>
    </div>
    <div class="btn-more" @click="viewMobileList">查看更多</div>
  </div>
</template>

<script>
import newsListMixins from '@/mixins/home/newsListMixins.js'

export default {
  mixins: [newsListMixins],
}
</script>

<style lang="scss" scoped>
.news-content {
  margin-top: 3.866666vw;
  padding: 0  4.266666vw;
  width: 100%;
  height: 93.733333vw;
  background: url('~@/assets/img/mobile/news_list_bg.png') no-repeat;
  background-size: 100%;
}

.news-tab {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1.733333vw;
  padding-top: 4.933333vw;

  &::after {
    content: '';
    position: absolute;
    bottom: -1.733333vw;
    width: 100%;
    height: 1px;
    background: #c3ad99;
  }

  &__item {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;

    .image {
      width: 13.6vw;
      height: 7.733333vw;
      background: url('~@/assets/img/mobile/news_type.png') no-repeat;
      background-size: 100% 30.933333vw;
    }
  }

  &--active {
    background: url('~@/assets/img/pc/news_type_active.png') no-repeat;
    background-size: 13.6vw;
    background-position: left bottom;
  }

  &__seperator {
    transform: rotate(45deg);
    margin-left: .8vw;
    width: 1.2vw;
    height: 1.2vw;
    background: #9a7b62;
  }

  &__type {
    &-latest .image {
      background-position: 0 0;
    }
    &-news .image {
      background-position: 0 -7.733333vw;
    }
    &-tips .image {
      background-position: 0 -15.466666vw;
    }
    &-activity .image {
      background-position: 0 -23.2vw;
    }
  }
}

.news-list {
  .box {
    width: 100%;
    height: 56.666666vw;
    ul {
      overflow: hidden;
      width: 100%;
      height: 100%;
    }

    li {
      display: flex;
      align-items: center;
      font-size: 2.933333vw;
    }

    .tag {
      margin-right: 1.6vw;
      width: 8.533333vw;
      height: 4.8vw;
      text-align: center;
      line-height: 4.8vw;
      color: #fff;
      background: #388176;
    }

    .title {
      flex: 1;
      color: #584c45;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .time {
      width: 14.4vw;
      font-size: 2.666666vw;
      color: #978d88
    }
  }
}

.news-item {
  padding: 3.2vw 0;
  border-bottom: .133333vw dashed #c6b5a5;
}

.btn-more {
  margin: 6.666666vw auto 0;
  width: 40.133333vw;
  height: 8.8vw;
  text-align: center;
  line-height: 8.8vw;
  font-size: 3.466666vw;
  color: #388176;
  background: url('~@/assets/img/mobile/more_btn.png') no-repeat;
  background-size: 100%;
}
</style>